import React, { useState } from 'react';
import styles from './TableOfContentsTab.module.css';
import { FaTimes } from 'react-icons/fa';

interface TableOfContentsTabProps {
    blocks?: any[];
    reportId?: string;
    reportTitle?: string;
}

const TableOfContentsTab: React.FC<TableOfContentsTabProps> = ({ blocks, reportId, reportTitle }) => {
    const [isVisible, setIsVisible] = useState(true);
    // Filter for TOC blocks and sort by sort_order
    const tocBlocks = blocks?.filter(b => b.block_type === 'toc')
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)) || [];

    if (!tocBlocks || tocBlocks.length === 0) {
        return <div className={styles.emptyState}>No table of contents available.</div>;
    }

    const hasHTML = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str || '');

    const handleNavigation = (e: React.MouseEvent) => {
        e.stopPropagation();
        const url = `/Customise?id=${reportId}&name=${encodeURIComponent(reportTitle || '')}&type=smp`;
        window.open(url, '_blank');
    };

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsVisible(false);
    };

    return (
        <div className={styles.tabContent}>
            {isVisible && (
                <div className={styles.stickyWrapper}>
                    <div className={styles.floatingContainer}>
                        <div className={styles.requestBanner} onClick={handleNavigation}>
                            <button className={styles.closeButton} onClick={handleClose} title="Close">
                                <FaTimes />
                            </button>
                            <div className={styles.innerButton}>
                                Request Customisation
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <h3 className={styles.contentHeading}>Table Of Contents</h3>
            <div className={styles.contentList}>
                {tocBlocks.map((block) => {
                    const sections = block.block_data_json?.sections || [];
                    return sections.map((section: any, index: number) => {
                        if (hasHTML(section.title)) {
                            return (
                                <div
                                    key={`${block.block_id}-${index}`}
                                    className={styles.listItem}
                                    dangerouslySetInnerHTML={{ __html: section.title }}
                                />
                            );
                        }

                        return (
                            <div key={`${block.block_id}-${index}`} className={styles.listItem}>
                                {section.title}
                            </div>
                        );
                    });
                })}
            </div>
        </div>
    );
};

export default TableOfContentsTab;
